<div tuiHeader="xxl">
  <div class="row">
    <h1 tuiTitle routerLink="">
      <img src="assets/images/logo_synapse_2025.png" alt="Logo" class="logo" />
    </h1>
    <div tuiGroup class="group" [collapsed]="true">
      <button appearance="outline" size="l" iconStart="@tui.house" routerLink="" title="Accueil" tuiIconButton
        type="button" [style.flex]="'0 0 auto'"></button>
      <button appearance="outline" size="l" iconStart="@tui.users" routerLink="/patient/list" title="Tout mes patients"
        tuiIconButton type="button" [style.flex]="'0 0 auto'"></button>
      <a appearance="outline" size="l" iconStart="@tui.globe" href="https://www.synapse-sante.fr/" target="vitrine"
        title="Site web de Synapse Santé" tuiIconButton type="button" [style.flex]="'0 0 auto'"></a>

      <button appearance="outline" size="l" iconStart="@tui.user" [routerLink]="['/profil', authService.user?.id]"
        title="Mon compte" tuiIconButton type="button" [style.flex]="'0 0 auto'"></button>
      <button appearance="outline" size="l" iconStart="@tui.log-out" (click)="logOut()" title="Me déconnecter"
        tuiIconButton type="button" [style.flex]="'0 0 auto'"></button>
    </div>
  </div>
</div>